import React from 'react';
import { IoIosExit } from 'react-icons/io';
import { HashLink } from 'react-router-hash-link';

function BtnPrimary({ text, className, onClick, type, isDisabled, key }) {
	return (
		<button
			id='btn-primary'
			key={key}
			type={type}
			onClick={onClick}
			className={`${className} text-white bg-purple hover:bg-purple-dark rounded-16 focus:outline-none font-normal text-sm shadow-btn `}
			disabled={isDisabled}
		>
			{text}
		</button>
	);
}

export { BtnPrimary };

const LinkPrimary = ({ className, isDisabled, children, ...rest }) => {
	return (
		<HashLink
			id='btn-primary'
			className={`${className} text-white bg-purple hover:bg-purple-dark rounded-16 focus:outline-none font-normal text-sm shadow-btn `}
			disabled={isDisabled}
			{...rest}
		>
			{children}
		</HashLink>
	);
};

function BtnAlternative({ text, className, onClick, exit, value }) {
	return (
		<button
			id='btn-alternative'
			value={value}
			type='button'
			onClick={onClick}
			className={`${className} text-[#77498F] bg-white-dark border border-solid border-purple-dark hover:bg-purple-dark-1 rounded-16 focus:outline-none font-normal text-sm shadow-btn`}
		>
			{exit && (
				<IoIosExit className='w-8 h-7 text-purple-dark inline ml-1' />
			)}
			{text}
		</button>
	);
}

export { BtnAlternative, LinkPrimary };

function BtnGray({ text, className, onClick, exit }) {
	return (
		<button
			type='button'
			onClick={onClick}
			className={`${className} text-[#F2F3F5] bg-[#71717199] hover:bg-white hover:border hover:border-[#71717199] hover:border-solid hover:text-[#71717199] rounded-16 focus:outline-none font-normal text-sm shadow-btn`}
		>
			{exit && (
				<IoIosExit className='w-8 h-7 text-purple-dark inline ml-1' />
			)}
			{text}
		</button>
	);
}

export { BtnGray };
